import $ from "jquery";
import { GAPageView } from "scripts/components/ga/page_view";
import header from "../components/header";
import sliders from "../components/sliders";
import inputSearch from "../components/inputSearch";
import response from "../components/response";
import forms from "../components/forms";
import modals from "../components/modals";
import wishlist from "../components/wishlist/wishlist";
import { initMinicardEvents } from "../components/minicard";
import Select from "../components/select";
import eSputnik from "../components/eSputnik";
import setAppLinksParams from "../components/setAppLinksParams";
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();


global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  header();
  sliders();
  inputSearch();
  response();
  forms();
  modals();
  wishlist();
  initMinicardEvents();
  eSputnik.MainPage();
  GAPageView();
  window.customSelect = new Select();
  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha()

  if ($(".block-seo").length) {
    const wrapper = $(".block-seo .wrapper:not(.opener-holder)");
    const height = wrapper.height();
    const realHeight = wrapper.prop("scrollHeight");

    if (realHeight <= height) {
      $(".block-seo .opener-holder").remove();
    }
  }
  $(".block-seo__opener").on("click", function showSeoText() {
    $(this).parents(".block-seo").toggleClass("active");
  });
});